import { View } from "@-/com.npmjs.react-native";
import { Progress } from "@-/dev.improve.haniverse.components.ui.progress";
import { Surface, SurfaceCollapsibleHeader } from "@-/dev.improve.haniverse.components.ui.surface";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import {
  LevelsPackDescriptionContent,
  type LevelsPackDescription,
} from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels._components.levels-list";
import { useLevelsPackSurfaceExpanded } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels._components.pinyin-sound-charts";
import { useLevelsPackProgress } from "#use-levels-pack-progress";

/** The pack description surface: its summary stays visible at the compact sheet stop. */
export function LevelsPackDescriptionSurface({
  description,
  onLayout,
  onSummaryLayout,
  title,
}: {
  description: LevelsPackDescription | null;
  onLayout?: (height: number) => void;
  onSummaryLayout?: (height: number) => void;
  title: string;
}) {
  const { isPending, progress } = useLevelsPackProgress();
  const { characterCount, learnedCharacterCount } = progress;
  const [isExpanded, setIsExpanded] = useLevelsPackSurfaceExpanded("description");
  return (
    <View
      className="px-1 pt-1"
      onLayout={(event) => onLayout?.(Math.ceil(event.nativeEvent.layout.height))}
    >
      <Surface testID="levels-pack-description">
        <View
          onLayout={(event) => onSummaryLayout?.(Math.ceil(event.nativeEvent.layout.height) + 4)}
        >
          <SurfaceCollapsibleHeader
            accessibilityLabel={
              isPending
                ? title
                : `${title}: ${learnedCharacterCount} of ${characterCount} characters learned`
            }
            className="items-center gap-1.5 py-3"
            isExpanded={isExpanded}
            onExpandedChange={setIsExpanded}
            testID="levels-pack-sheet-header"
          >
            <Text className="text-base leading-5 font-semibold text-foreground" numberOfLines={1}>
              {title}
            </Text>
            <Progress
              className="h-2 rounded-full bg-foreground/10"
              indicatorClassName="rounded-full bg-foreground/70"
              testID="levels-pack-sheet-progress"
              value={
                isPending || characterCount === 0
                  ? 0
                  : (learnedCharacterCount / characterCount) * 100
              }
            />
          </SurfaceCollapsibleHeader>
        </View>
        {isExpanded && description !== null ? (
          <View className="px-3 py-2.5" testID="levels-pack-description-body">
            <LevelsPackDescriptionContent {...description} showHeading={false} />
          </View>
        ) : null}
      </Surface>
    </View>
  );
}
